module.exports = [
	{
		"source": "For more information on the methodology, please consult The Science behind Forest Mapper:",
		"sourceurl": "https://www.canopyplanet.org/tools/forestmapper/sciencebehind"
	},
	{
		"source": "There are 25 \"core\" datasets and foundational frameworks that went into making the Ancient and Endangered composite dataset, excluding the background and administrative data, which are excluded from this list. The sources below were last accessed on December 15, 2015."
	},
	{
		"source": "Intact forest landscapes (2013; 2010). Greenpeace, University of Maryland, World Resources Institute and Transparent World. \"Intact Forest Landscapes. 2000/2013\" (2013 globally; 2013 Indonesia; 2010 Canada)",
		"sourceurl": "http://data.globalforestwatch.org/datasets/ab914731bbd04a2298354d71dc5a9f62_0"
	},
	{
		"source": "Intact forest landscapes for Indonesia (2013):",
		"sourceurl": "http://data.globalforestwatch.org/datasets/b3ac8839275446b5983c0271fddf1e33"
	},
	{
		"source": "Intact forest landscapes for Canada (2010):",
		"sourceurl": "https://databasin.org/galleries/0267510a7beb4142a55857290b8f922a#expand=152261"
	},
	{
		"source": "Priority forest ecoregions - (WWFs Global 200) (2002). World Wildlife Fund. Priority Forest Ecoregions. Ecoregions of the World (Global 200) 2002. Accessed through:",
		"sourceurl": "http://databasin.org/datasets/a5b34649cc69417ba52ac8e2dce34c3b"
	},
	{
		"source": "Biologically rich and deeply threatened forested hotspots (Conservation International) (2014). Conservation International. 2011. Biodiversity Hotspots. Accessed through:",
		"sourceurl": "https://www.globalforestwatch.org"
	},
	{
		"source": "Temperate and Boreal Rainforests (2011). Henrik vonWehrden in DellaSala, DA editor. 2010. Temperate and Boreal Rainforests of the World. Island Press, Washington DC. 336 pp. Accessed through:",
		"sourceurl": "http://databasin.org/maps/96307c4ce4284ad99ba3dee3be506492"
	},
	{
		"source": "Species diversity hotspots (mammals, birds, amphibians) (2015). Hotspots of species diversity and richness (mammals, birds, amphibians). 2015. BiodiversityMapping.org, BirdLife International, IUCN, and NatureServe Biodiversity. (original source) http://www.biodiversitymapping.org/download.htm. Accessed through:",
		"sourceurl": "http://databasin.org/datasets/bdc972049e0f476481e2c1f572fe7eeb"
	},
	{
		"source": "Global Vegetation biomass – carbon stocks - 1km  - resolution (2010). Ruesch, Aaron, and Holly K. Gibbs. 2008. New IPCC Tier-1 Global Biomass Carbon Map For the Year 2000. Accessed through:",
		"sourceurl": "https://databasin.org/datasets/2d7ed4b20ed2439f8ba3d2976d6aa801"
	},
	{
		"source": "Sumatran tiger (1995-2005). Wildlife Conservation Society, World Wildlife Fund, Smithsonian Institution, Save the Tiger Fund. 2006. Accessed through:",
		"sourceurl": "https://databasin.org/datasets/213f9dfd508945dd88eff1e1787f3564"
	},
	{
		"source": "Sumatran Rhinoceros (2011). Wahab, A., J. Payne, A. Mohamed, C. Lau, D. Sharma, R. Amirtharaj, S. Nathan, W. Ramono and G. Clements. 2011. Now or never: what will it take to save the Sumatran rhinoceros Dicerorhinus sumatrensis from extinction? Borneo Rhino Alliance. Fauna & Flora International, Oryx, 45(2), 225–233. Canopy digitized the 2011 Sumatran Rhinoceros population range from Figure 1 in the source publication. Available at:",
		"sourceurl": "http://www.borneorhinoalliance.org/wp- content/uploads/2014/02/Abdul_Wahab_et_al_2011.pdf"
	},
	{
		"source": "Javan Rhinoceros (1997). Thomas J. and van Strien, Nico. 1997, Asian Rhinos – Status Survey and Conservation Action Plan. IUCN, Gland, Switzerland, and Cambridge, UK, ISBN 2-8317-0336-0 (available at: http://www.rhinoresourcecenter.com/pdf_files/117/1175857641.pdf) Accessed through:",
		"sourceurl": "https://commons.wikimedia.org/wiki/File:Javan_Rhino_Range.svg"
	},
	{
		"source": "Sumatran elephant (2012). Watts, Jonathan. 2012. Sumatran elephant upgraded to critically endangered status. World Wildflie Fund. Canopy digitized the 2008 Sumatran elephant population range from the World Wildlife Fund, Decline of the Sumatran elephant map featured in The Guardian on January 24, 2012.",
		"sourceurl": "http://www.theguardian.com/environment/2012/jan/24/sumatran-elephant-upgraded-critically-endangered"
	},
	{
		"source": "Borneo elephant (2010). This dataset was utilized for general and important context information only, and is not displayed on the Ancient and Endangered Forests Map. Further analysis or higher quality data on this topic may need to be acquired. Further information can be found at:",
		"sourceurl": "http://www.soselephants.com/borneo-elephants.html"
	},
	{
		"source": "Java leopard (2011). Gunawan, H., L. Prasetyo, A. Mardiastuti, A. Kartano. 2011. Habitat Suitability of Javan Leopard in Central Java Landscape. Institut Pertanian Bogor. Poster. Canopy digitized the 2011 Java leopard population range. Accessed through:",
		"sourceurl": "http://lbprastdp.staff.ipb.ac.id/files/2011/12/POSTER_HABITAT_SUITABILITY_OF_JAVAN_LEOPARD__EDITED_.pdf"
	},
	{
		"source": "Sumatran Orangutan (2012). UNEP-WCMC and IUCN. 2015. Pongo abelii. The IUCN Red List of Threatened Species. Version 2012.1. Accessed through:",
		"sourceurl": "http://maps.iucnredlist.org/map.html?id=121097935"
	},
	{
		"source": "Indonesia peatlands (2010). Saxon, Earl and Stu Sheppard. 2010. Land Systems of Indonesia and Papua New Guinea.  Accessed through the following (from Land Systems of Indonesia and New Guinea, extract 02 Wetlands and Swamps):",
		"sourceurl": "http://databasin.org/datasets/eb74fe29b6fb49d0a6831498b0121c99"
	},
	{
		"source": "Leuser Ecosystem (date unknown). Accessed through:",
		"sourceurl": "http://data.globalforestwatch.org/datasets/16dae98167264b8abfbd13e23802e4f3_0"
	},
	{
		"source": "Primary Forests. This dataset was utilized for general and important context information only, and is not displayed on the Ancient and Endangered Forests Map. Further analysis or higher quality data on this topic may need to be acquired. Accessed through:",
		"sourceurl": "http://data.globalforestwatch.org/datasets/b3ac8839275446b5983c0271fddf1e33 (Indonesia primary forests [2000]) "
	},
	{
		"source": "Tropical forest carbon stocks (2000). This dataset was utilized for general and important context information only, and is not displayed on the Ancient and Endangered Forests Map. Further analysis or higher quality data on this topic may need to be acquired. Accessed through the following, using Tropical forest carbon stocks (2000): ",
		"sourceurl": "http://data.globalforestwatch.org/datasets/bb7efe571e344aa6a42882803f73685f"
	},
	{
		"source": "Woodland Caribou (2010). Environment Canada, 2010. Dataset no longer available externally. ",
		"sourceurl": ""
	},
	{
		"source": "Southern and Northern Mountain Caribou (2012). Environment Canada. 2014. Recovery Strategy for the Woodland Caribou, Southern Mountain population (Rangifer tarandus caribou) in Canada [Proposed]. Species at Risk Act Recovery Strategy Series. Environment Canada, Ottawa. viii + 68 pp. Accessed through:",
		"sourceurl": "http://www.sararegistry.gc.ca/virtual_sara/files/plans/mp_woodland_caribou_northern_mountain_population_e.pdf"
	},
	{
		"source": "Southern and Northern Mountain Caribou (2012). Additional information accessed through:",
		"sourceurl": "http://www.sararegistry.gc.ca/virtual_sara/files/plans/rs_woodland_caribou_bois_s_mtn_pop_0114_e.pdf"
	},
	{
		"source": "Forest Age (2004). This dataset was utilized for general and important context information only, and is not displayed on the Ancient and Endangered Forests Map. Further analysis or higher quality data on this topic may need to be acquired. NCAP Forest Age Maps at 1-km Resolution for Canada (2004) and the United States (2006). Pan, Y., Chen, J. M., Birdsey, R., McCullough, K., He, L., and Deng, F.: Age structure and disturbance legacy of North American forests, Biogeosciences, 8, 715-732, doi:10.5194/bg-8-715-2011, 2011.  Accessed through:",
		"sourceurl": "https://webmap.ornl.gov/wcsdown/dataset.jsp?ds_id=1096"
	},
	{
		"source": "Ducks Unlimited Hydrid Wetlands (2010 ). Data is available on request from Ducks Unlimited. ",
		"sourceurl": "https://www.ducks.ca/about/contact/"
	},
	{
		"source": "Soil Organic Carbon (1995). This dataset was utilized for general and important context information only, and is not displayed on the Ancient and Endangered Forests Map. Further analysis or higher quality data on this topic may need to be acquired. Soil Carbon of Canada Database accessed through:",
		"sourceurl": "http://sis.agr.gc.ca/cansis/interpretations/carbon/index.html"
	},
	{
		"source": "FRAMEWORKS"
	},
	{
		"source": "Forest Stewardship Council. High Conservation Value Forest Assessment Framework. Revised draft, 2010. Accessed Sept 11, 2017:",
		"sourceurl": "https://us.fsc.org/preview.fsc-us-hcvf-assessment-framework.a-190.pdf"
	},
	{
		"source": "Forest Stewardship Council: FSC Board of Directors. 2015. International Generic Indicators FSC-STD-60-004 V1.0. Available at:",
		"sourceurl": "http://igi.fsc.org/approved-documents.60.htm"
	},
	{
		"source": "Wye Group discussion document. 2002. Endangered Forests: Priority High Conservation Value Forests for Protection Guidance for Corporate Commitments Forest Leadership Forum: Collaborative Pathways to Responsible Trade April 25-27, 2002, Cobb Galleria, Atlanta Georgia. Accessed Sept. 11, 2017.",
		"sourceurl": "http://www.greenpeace.org/usa/research/endangered-forests-definition/"
	},
	{
		"source": "Ecological Components of Endangered Forests. April 2006. ForestEthics, Greenpeace, Natural Resources Defense Council, and Rainforest Action Network. Available at",
		"sourceurl": "http://www.greenpeace.org/wp-content/uploads/legacy/Global/usa/report/2010/2/endangered-forests-technical-d.pdf"
	},
	{
		"source": "The HCS Approach Toolkit: Putting No Deforestation in Practice. Version 1.0 March 2015. Available at:",
		"sourceurl": "http://highcarbonstock.org/the-hcs-approach-toolkit/"
	}
];


//////////////////
// WEBPACK FOOTER
// ./data/aef_sources.json
// module id = 546
// module chunks = 1